import { useState } from 'react'
import { NavLink, Navigate, useNavigate } from 'react-router-dom'
import { ReactComponent as Hamburger } from '../../assets/images/hamburger.svg'
// import HamburgerClose from '../../assets/images/hamburger_close.svg'
// import Brand from '../../assets/images/logo.svg'
// import downArrow from "../../assets/images/down-arrow.svg"
import './navbar.css'
import AnnualReport2425 from '../../assets/Pdf/FY 2024-2025.pdf'
import AnnualReport2324 from '../../assets/Pdf/MGT-7 - FY 2023-24.pdf'
import AnnualReport2223 from '../../assets/Pdf/FY 2022-2023.pdf'
import AnnualReport2122 from '../../assets/Pdf/FY 2021-2022.pdf'
import AnnualReport2021 from '../../assets/Pdf/FY 2020-2021.pdf'
import AnnualReport1920 from '../../assets/Pdf/FY 2019-2020.pdf'




const Navbar = () => {
    const [showNavbar, setShowNavbar] = useState(true)
    const [OpenDropDown, setOpenDropDown] = useState(false)
    const [submenuOpen, setSubmenuOpen] = useState(false);
    const [arrowDirection, setArrowDirection] = useState('right');
    const navigate = useNavigate();

      const handleMouseHover = (isHovering) => {
        setOpenDropDown(isHovering);
        setArrowDirection(isHovering ? 'down' : 'right');
      };

    return (
        <>
            <header>
                <nav className="navbar">
                    <div className="container">
                        <div className="logo" onClick={(e)=>navigate('/')}>
                            {/* <img src={Brand} alt="" className='logo' /> */}
                            <img src={`${process.env.REACT_APP_IMAGEBASE_URL}/logo.svg`} alt="" className='logo' />

                        </div>
                        {      window.innerWidth < "450" &&<div className="logo2" >
                            {/* <img src={Brand} alt="" className='logo' /> */}
                            <img src={`https://production-nuego-cms.blr1.digitaloceanspaces.com/static-contents/prod-v1/achieve2_034fd3c23b.png`} alt="" className='logo2' />

                        </div>}
          
                        <div className="menu-icon" onClick={(e) => setShowNavbar(o => !o)}>
                            <Hamburger />
                        </div>
                        <div className={`nav-elements  ${showNavbar == true ? 'headerBlock' : "headerNone"}`}>
                            <button className='HamburgerClose-btn' onClick={(e) => setShowNavbar(o => !o)}>
                                 {/* <img src={HamburgerClose} alt="HamburgerClose" /> */}
                                 <img src={`${process.env.REACT_APP_IMAGEBASE_URL}/hamburger_close.svg`} alt="HamburgerClose" />

                            </button>
                            <ul>
                                <li>
                                    <NavLink to="/">Home</NavLink>
                                </li>
                                <li>
                                    <NavLink to="/AboutUs">About </NavLink>
                                </li>
                                {/* <li>
                                    <NavLink to="https://nuego.in/news" target='_blank'>News</NavLink>
                                </li> */}
                                <li>
                                    <NavLink to="/news" >News</NavLink>
                                </li>

                                <li>
                                    <NavLink to="/portfolio">Portfolio</NavLink>
                                </li>
                                <li>
                                    <NavLink to="/sustainability">Sustainability</NavLink>
                                </li>
                                <li className='dropdown-bar '
                                         onMouseEnter={() => handleMouseHover(true)}
                                         onMouseLeave={() => handleMouseHover(false)}>
                                    <NavLink to="javascript:void(0);"
                                    >Governance
                                    <svg className={`arrow-icon ${arrowDirection}`} xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>
                                    {/* <img src={`${process.env.REACT_APP_IMAGEBASE_URL}/down-arrow.svg`} alt="" />  */}
                                    </NavLink>
                                    {OpenDropDown && <ul
                                        className={`dropdown-menu ${showNavbar == false ? "dropdownmenu" : "dropdown-menu"} `}
                                    // className='dropdown-menu'
                                    >
                                        <li>
                                        {/* <NavLink to="javascript:void(0);" class="dropdown-item">Code of Business Conduct</NavLink> */}

                                            <NavLink to="/CodeofBusinessConduct" class="dropdown-item">Code of Business Conduct</NavLink>
                                            
                                        </li>
                                        {/* <li>
                                            <NavLink to="javascript:void(0);" class="dropdown-item">E-Waste Management</NavLink>
                                        </li> */}
                                        <li className="dropdown-submenu">
                                            <NavLink to="" class="dropdown-item"
                                             onClick={(e) => {
                                                e.preventDefault();
                                                setSubmenuOpen((prev) => !prev);
                                                }}
                                            >Annual Return</NavLink> 
                                              <ul className={`sub-dropdown-menu ${submenuOpen ? 'mobile-open' : ''}`}>
                                                <li>
                                                <a
                                                    href={AnnualReport2425+'#toolbar=0'}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="dropdown-item"
                                                >
                                                    FY 24-25
                                                </a>
                                                                                                <a
                                                    href={AnnualReport2324+'#toolbar=0'}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="dropdown-item"
                                                >
                                                    FY 23-24
                                                </a>
                                                                                                <a
                                                    href={AnnualReport2223+'#toolbar=0'}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="dropdown-item"
                                                >
                                                    FY 22-23
                                                </a>
                                                                                                <a
                                                    href={AnnualReport2122+'#toolbar=0'}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="dropdown-item"
                                                >
                                                    FY 21-22
                                                </a>
                                                                                                <a
                                                    href={AnnualReport2021+'#toolbar=0'}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="dropdown-item"
                                                >
                                                    FY 20-21
                                                </a>
                                                                                                <a
                                                    href={AnnualReport1920+'#toolbar=0'}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="dropdown-item"
                                                >
                                                    FY 19-20
                                                </a>
                                                </li>
                                            </ul>
                                        </li>
                                         <li>
                                            <NavLink to="/EwasteManagement" class="dropdown-item">E-Waste Management</NavLink>
                                        </li>

                                    </ul>}
                                </li>
                                <li
                                //  onClick={(e)=>{navigate("#contactss")} }
                                >
                                    <NavLink to="/Contact">Contact us</NavLink>
                                </li>
                            </ul>
                        </div>

                        {      window.innerWidth > "1024" &&<div className="logo2" >
                            {/* <img src={Brand} alt="" className='logo' /> */}
                            <img src={`https://production-nuego-cms.blr1.digitaloceanspaces.com/static-contents/prod-v1/achieve2_034fd3c23b.png`} alt="" className='logo2' />

                        </div>}
                    </div>
                </nav>

            </header>


        </>
    )
}

export default Navbar